<!-- <button class="new-version" *ngIf="!this.compositeDesign" (click)="goToNewVersion()">לנסות גרסה חדשה</button> -->
<!-- <app-threejs #three *ngIf="ifThree" [currentBuilding]="this.currentBuilding"></app-threejs> -->
<span *ngIf="unika" class="question" (click)=showCurrentExplanation($event)>?</span>
<div class="explanation left">
    <div class="all-wrapper"></div>
    <span class="close-explanation" (click)="closeExplanation()"></span>
    <span class="step-number">1</span>
    <span class="text">
        סכמה של כל הדירות בבניין לפי קומות. <br />
        בלחיצה על הדירה יפתח דף עם המידע של אותה הדירה.
    </span>
    <div class="explanation-nav">
        <button class="btn prev-step" (click)="prevnextF($event, 'next')">הבאה</button>
        <button class="btn next-step" (click)="prevnextF($event, 'prev')">קודם</button>
    </div>
</div>


<span *ngIf="proj">
    <lottie-player *ngIf="this.showIntro && unika && !proj[0].hideIntro" (click)="this.showIntro = !this.showIntro"
        class="intro" id="intro" src="https://lottie.host/5dbc5c3a-42b6-4bb5-b8ab-7e24ddaf2df5/Xtx9AYVBUE.json"
        background="transparent" speed="2" count="1" loop autoplay></lottie-player>
</span>

<div *ngIf="showComponents && this.showProject && !unika && this.translate.currentLang"
    [class.composite-design-proj-building]="compositeDesign" [class.closed-panel]="closeBuildingPanel || currentFlatsPanelOnClickShow">
    <div class="buildings-holder" [class.move-building-menu-full]="moveBuildingMenuFull" [class.threejs]="ifThree"
        [class.opened-flat]="!withBuilding" [class.move-building-menu-half]="moveBuildingMenuHalf"
        *ngIf="compositeDesign && showBuilding" (mouseover)="moveBuildinMenuFalse('half')">
        <div *ngIf="!unika" class="building-trigger closer-triger" (click)="moveBuildinMenu('full')"></div>
        <div class="filters-holder" *ngIf="!showFlatProperties">
            <app-building-list class="dropdown" *ngIf="compositeDesign && proj" [projId]="proj[0].id"
                [routeParams]="routeParams" (currentBuilding1)="currentBuildingF($event)"></app-building-list>
            <app-floors-choice *ngIf="compositeDesign && unika && refresh"></app-floors-choice>
            <app-how-much-rooms class="dropdown" *ngIf="compositeDesign" [building]="currentBuilding"
                (currentRoomAmount)="currentRoomAmountF($event)"></app-how-much-rooms>
            <!-- <app-how-much-rooms #howMuchRooms *ngIf="compositeDesign && unika && refresh" [building]="currentBuilding"
                (currentRoomAmount)="currentRoomAmountF($event)"></app-how-much-rooms> -->
            <app-flat-sale-status class="dropdown" *ngIf="compositeDesign" (flatStatusClass)="flatStatusClassF($event)">
            </app-flat-sale-status>
            <!-- <app-flat-sale-status *ngIf="compositeDesign && unika && refresh"
                (flatStatusClass)="flatStatusClassF($event)">
            </app-flat-sale-status> -->
        </div>
        <a *ngIf="compositeDesign && showFlatProperties && !removeCloseButton && this.withBuilding"
            class="close right-long-arrow" href="javascript:;" (click)='closeFlatProperties($event)'><span></span></a>
        <app-flat-properties-test #cmp *ngIf="compositeDesign" [class.show-flat-properties]="showFlatProperties"
            (hideFlatPropeties)="closeFlatProperties($event)">
        </app-flat-properties-test>
        <span class="floor-title" *ngIf="compositeDesign && !showFlatProperties && desktopResolution">{{ 'FLOOR' |
            translate }}</span>
        <app-viewbuildigs-test *ngIf="compositeDesign && !showFlatProperties" [currentRoomAmount]="currentRoomAmount"
            [flatStatusClassValue]="flatStatusClass"></app-viewbuildigs-test>
    </div>
    <div class="projects" *ngIf="proj?.length > 0 && !this.showBuildings" (mouseenter)="moveBuildinMenu('half')">
        <div *ngFor="let item of proj">

            <!-- <div *ngIf="this.illustrationOnly" class="illustration-only">{{ 'ILLUSTRATION-ONLY' |
                translate }}</div> -->
            <div *ngIf="this.illustrationOnly" class="illustration-only"><span
                    *ngIf="!this.illustrationOnlyNote || !desktopResolution">{{
                    'ILLUSTRATION-ONLY' | translate }}</span>
                <span class="illustration-only-note" *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote |
                    translate }}</span>
            </div>
            <div *ngIf="this.currentLanguage === 'he'" class="col m12 iframe da-iframe" [innerHtml]="proj[0].spirical | safe: 'html'">
            </div>
            <div *ngIf="this.currentLanguage === 'en'" class="col m12 iframe da-iframe" [innerHtml]="proj[0].spiricalEn | safe: 'html'">
            </div>
            <app-wind-rose *ngIf="sceneTitleArray.length > 0 && this.refresh" [sceneTitleArray]="this.sceneTitleArray"
                [curSceneName]="this.curSceneName"></app-wind-rose>
            <app-current-situation *ngIf="sceneTitleArray.length > 0 && unika && this.refresh"
                [sceneTitleArray]="this.sceneTitleArray">
            </app-current-situation>
            <app-gallery [galleryId]="'1'" [section]="compId+'logo-project-up'" [autoPlay]="false" [showThumbs]="false"
                class="slogan-img slogan-img-project-up"></app-gallery>
            <app-gallery [galleryId]="'1'" [section]="item.id+'logo-project-down'" [autoPlay]="false"
                [showThumbs]="false" class="slogan-img slogan-img-project-down"></app-gallery>
            <app-gallery (click)="openFake3d()" [galleryId]="'1'" [section]="item.id+'logo-project-right-down'"
                [autoPlay]="false" [showThumbs]="false" style="display: block;"
                class="slogan-img slogan-img-project-right-down">
            </app-gallery>
            <app-gallery [galleryId]="'1'" [section]="item.id+'logo-project-left-top'" [autoPlay]="false"
                [showThumbs]="false" style="display: block;" class="slogan-img slogan-img-project-left-top">
            </app-gallery>
            <app-gallery [galleryId]="'1'" [section]="item.id+'editional-gallery'" [autoPlay]="false"
                [showThumbs]="false" style="display: block;" class="slogan-img slogan-img-project-left-top">
            </app-gallery>
        </div>
    </div>
</div>
<div *ngIf="this.proj">
    <div *ngIf="showComponents && this.showProject && unika && this.translate.currentLang && this.compId === this.proj[0].parrentId"
        [class.composite-design-proj-building]="compositeDesign" [class.closed-panel]="closeBuildingPanel || currentFlatsPanelOnClickShow">
        
        <!-- <app-right-menu *ngIf="proj && unika" [proj]="proj[0]"></app-right-menu> -->
        <div *ngIf="this.building">
            <div class="buildings-holder" [class.move-building-menu-full]="moveBuildingMenuFull"
                [class.threejs]="ifThree" [class.full-wide-building-holder]="showFlatProperties"
                [class.opened-flat]="!withBuilding" [class.move-building-menu-half]="moveBuildingMenuHalf"
                *ngIf="compositeDesign && showBuilding && this.building.compId === this.compId"
                (mouseover)="moveBuildinMenuFalse('half')"
                [class.closed-panel]="closeBuildingPanel || currentFlatsPanelOnClickShow"
                [class.hide-border]="this.showFlatProperties">
                <a *ngIf="showFloorPlan" class="close-section close-floor-plan" (click)="closeFloorDrawing()"></a>
                <app-drawing-floors *ngIf="showFloorPlan && refresh" class="floor-gallery"
                [drawingHolderWidth]="1000" [item]="floorId"></app-drawing-floors>
                <a *ngIf="!this.showFlatProperties" href="javscript:;" class="close-section close-building-section"
                    (click)="togglePanel()"></a>
                <div *ngIf="!unika" class="building-trigger closer-triger" (click)="moveBuildinMenu('full')"></div>
                <div class="filters-holder" *ngIf="!showFlatProperties">
                    <div class="title-holder">
                        <div class="icon-holder"></div>
                        <div  *ngIf="this.building.buildType !== 'office' || !desktopResolution" class="title">{{ buildingTitle }}</div>
                        <button  *ngIf="this.building.buildType === 'office' && desktopResolution" (click)="showFloorPlan = !showFloorPlan" class="title">{{ buildingTitle }}</button>
                    </div>
                    <app-building-list class="dropdown" *ngIf="compositeDesign && proj" [projId]="proj[0].id"
                        [class.hide]="unika" [routeParams]="routeParams" (currentBuilding1)="currentBuildingF($event)">
                    </app-building-list>
                    <div class="mobile-filters-holder" [class.active]="showFilters">
                        <div class="top-holder-filters title-holder sub-title" (click)="showFilters = !showFilters">
                            <div class="icon-holder"></div>
                            <div class="title"> {{ 'FILTERS' | translate }} </div>
                            <div class="dropdown-trigger" [class.active]="showFilters"></div>
                        </div>
                        <div class="floors-choise-holder filter-holder" *ngIf="buildType !== 'office'">
                            <!-- <div class="filter-title floor-title">קומה:</div> -->
                            <app-floors-choice *ngIf="compositeDesign && unika && refresh"></app-floors-choice>
                        </div>
                        <div class="floors-choise-howMuchRooms filter-holder" *ngIf="this.hideRoomNumberProperty && buildType !== 'office'">
                            <!-- <div class="filter-title numberOfRooms-title">חדרים:</div> -->
                            <app-how-much-rooms #howMuchRooms
                                *ngIf="compositeDesign && unika && refresh && this.currentBuilding"
                                [building]="currentBuilding" (currentRoomAmount)="currentRoomAmountF($event)">
                            </app-how-much-rooms>
                        </div>
                        <div class="floors-choise-status filter-holder">
                            <!-- <div class="filter-title flat-status-title">סטטוס:</div> -->
                            <app-flat-sale-status *ngIf="compositeDesign && unika && refresh"
                                (flatStatusClass)="flatStatusClassF($event)">
                            </app-flat-sale-status>
                        </div>
                        <div class="floors-choise-falt-prototype filter-holder" *ngIf="this.showProtoFilter">
                            <app-flat-prototypes-filter [building]="currentBuilding"
                                *ngIf="compositeDesign && unika && refresh"
                                (currentPrototype)="currentFlatPrototypeF($event)"></app-flat-prototypes-filter>
                        </div>
                    </div>
                </div>
                <!-- <a *ngIf="compositeDesign && showFlatProperties && !removeCloseButton && this.withBuilding"
            class="close right-long-arrow" href="javascript:;" (click)='closeFlatProperties($event)'><span></span></a> -->
                <span class="floor-title"
                    *ngIf="compositeDesign && !showFlatProperties && desktopResolution && !unika">{{
                    'FLOOR' |
                    translate }}</span>
                <app-viewbuildigs-test *ngIf="compositeDesign && !showFlatProperties"
                    (currentBuilding)="currentBuildingF($event)" [currentRoomAmount]="currentRoomAmount"
                    [flatStatusClassValue]="flatStatusClass"></app-viewbuildigs-test>
                <app-flat-properties-test #cmp *ngIf="compositeDesign" [class.show-flat-properties]="showFlatProperties"
                    (hideFlatPropeties)="closeFlatProperties($event)">
                </app-flat-properties-test>
            </div>
        </div>
        <!--       ----------------------------------if 3d model start slider -------------------------------------------- -->
        <div class="projects" *ngIf="proj?.length > 0 && this.ifThree">
            <div *ngFor="let item of proj">
                <!-- <mat-tab-group mat-align-tabs="start">

                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="lable-holder">
                            <mat-icon class="icon-3d"></mat-icon>
                            תלת מימד
                        </div>
                    </ng-template>
                    <div class="3d-flat-holder-project">
                        <app-threejs #three *ngIf="ifThree" [currentBuilding]="this.currentBuilding"></app-threejs>

                    </div>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="lable-holder" (click)="activateRoseF()">
                            <mat-icon class="spirikal-pano-icon"></mat-icon>
                            {{ 'SPIRIKAL' | translate }}
                        </div>
                    </ng-template>
                    <app-wind-rose #rose *ngIf="sceneTitleArray.length > 0" [sceneTitleArray]="this.sceneTitleArray"
                        [curSceneName]="this.curSceneName"></app-wind-rose>
                    <app-current-situation *ngIf="sceneTitleArray.length > 0 && unika"
                        [sceneTitleArray]="this.sceneTitleArray"></app-current-situation>
                    <div class="col m12 iframe da-iframe" [innerHtml]="item.spirical | safe: 'html'">
                    </div>
                </mat-tab>

            </mat-tab-group> -->

                <div class="holder-3d-project" [class.fullWidthPropertiesPanel]="fullWidthPropertiesFlatPanel"
                    [class.move-canvas]="currentFlatsPanelOnClickShow">
                    <app-threejs #three *ngIf="ifThree" [mainSpirikal]="this.item.spirical" [currentBuilding]="this.currentBuilding"></app-threejs>
                </div>

                <app-gallery [galleryId]="'1'" [section]="compId+'logo-project-up'" [autoPlay]="false"
                    [showThumbs]="false" class="slogan-img slogan-img-project-up"></app-gallery>
                <app-gallery [galleryId]="'1'" [section]="item.id+'logo-project-down'" [autoPlay]="false"
                    [showThumbs]="false" class="slogan-img slogan-img-project-down"></app-gallery>
                <app-gallery (click)="openFake3d()" [galleryId]="'1'" [section]="item.id+'logo-project-right-down'"
                    [autoPlay]="false" [showThumbs]="false" style="display: block;"
                    class="slogan-img slogan-img-project-right-down">
                </app-gallery>
                <app-gallery [galleryId]="'1'" [section]="item.id+'logo-project-left-top'" [autoPlay]="false"
                    [showThumbs]="false" style="display: block;" class="slogan-img slogan-img-project-left-top">
                </app-gallery>
                <app-gallery [galleryId]="'1'" [section]="item.id+'editional-gallery'" [autoPlay]="false"
                    [showThumbs]="false" style="display: block;" class="slogan-img slogan-img-project-left-top">
                </app-gallery>
            </div>
        </div>
        <!--       ----------------------------------if 3d model end slider -------------------------------------------- -->


        <div class="projects" *ngIf="proj?.length > 0 && !this.showBuildings && !showFlatProperties && !this.ifThree"
            (mouseenter)="moveBuildinMenu('half')">

            <div *ngFor="let item of proj">

                <!-- <div *ngIf="this.illustrationOnly" class="illustration-only">{{ 'ILLUSTRATION-ONLY' |
                    translate }}</div> -->
                <div *ngIf="this.illustrationOnly" class="illustration-only"><span
                        *ngIf="!this.illustrationOnlyNote || !desktopResolution">{{
                        'ILLUSTRATION-ONLY' | translate }}</span>
                    <span class="illustration-only-note" *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote
                        | translate }}</span>
                </div>
                <div *ngIf="!this.ifThree && this.currentLanguage === 'he'" class="col m12 iframe da-iframe" [innerHtml]="item.spirical | safe: 'html'">
                </div>
                <div *ngIf="!this.ifThree && this.currentLanguage === 'en'" class="col m12 iframe da-iframe" [innerHtml]="item.spiricalEn | safe: 'html'">
                </div>
                <!-- <div class="scene-navigator" (mouseenter)="showRoseWind('in')"> -->
                    <div class="scene-navigator">
                        <!-- <span class="tooltip justDescktop" *ngIf="sceneTitleArray.length > 0 && !this.ifThree">{{
                            'ANOTHER-LOOK' | translate }}</span> -->
                    <app-current-situation *ngIf="sceneTitleArray.length > 0 && unika && !this.ifThree"
                        [sceneTitleArray]="this.sceneTitleArray">
                    </app-current-situation>
                    <app-wind-rose *ngIf="sceneTitleArray.length > 0 && !this.ifThree"
                        [sceneTitleArray]="this.sceneTitleArray" [curSceneName]="this.curSceneName"></app-wind-rose>
                </div>

                <!-- <div *ngFor="let item of proj"> -->






                <app-gallery [galleryId]="'1'" [section]="compId+'logo-project-up'" [autoPlay]="false"
                    [showThumbs]="false" class="slogan-img slogan-img-project-up"></app-gallery>
                <app-gallery [galleryId]="'1'" [section]="item.id+'logo-project-down'" [autoPlay]="false"
                    [showThumbs]="false" class="slogan-img slogan-img-project-down"></app-gallery>
                <app-gallery (click)="openFake3d()" [galleryId]="'1'" [section]="item.id+'logo-project-right-down'"
                    [autoPlay]="false" [showThumbs]="false" style="display: block;"
                    class="slogan-img slogan-img-project-right-down">
                </app-gallery>
                <app-gallery [galleryId]="'1'" [section]="item.id+'logo-project-left-top'" [autoPlay]="false"
                    [showThumbs]="false" style="display: block;" class="slogan-img slogan-img-project-left-top">
                </app-gallery>
                <app-gallery [galleryId]="'1'" [section]="item.id+'editional-gallery'" [autoPlay]="false"
                    [showThumbs]="false" style="display: block;" class="slogan-img slogan-img-project-left-top">
                </app-gallery>
            </div>
        </div>
    </div>
</div>
<div class="lds-facebook" *ngIf="!showComponents">
    <div></div>
    <div></div>
    <div></div>
</div>

<app-jitsi></app-jitsi>
